import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _process;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { isVCRevisionEnabled } from '../config';
import { VCObserverNOOP } from './no-op-vc-observer';
import { VCObserver } from './vc-observer';
import VCObserverNew from './vc-observer-new';
var VCObserverWrapper = /*#__PURE__*/function () {
  function VCObserverWrapper() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, VCObserverWrapper);
    this.newVCObserver = null;
    if (fg('platform_ufo_vc_enable_revisions_by_experience')) {
      this.oldVCObserver = null;
      if (isVCRevisionEnabled('fy25.03')) {
        this.newVCObserver = new VCObserverNew({
          selectorConfig: opts.selectorConfig
        });
      }
      if (isVCRevisionEnabled('fy25.01') || isVCRevisionEnabled('fy25.02')) {
        this.oldVCObserver = new VCObserver(opts);
      }
    } else {
      if (isVCRevisionEnabled('fy25.03')) {
        this.newVCObserver = new VCObserverNew({
          selectorConfig: opts.selectorConfig
        });
      }
      this.oldVCObserver = new VCObserver(opts);
    }
  }
  return _createClass(VCObserverWrapper, [{
    key: "start",
    value: function start(_ref) {
      var startTime = _ref.startTime,
        experienceKey = _ref.experienceKey;
      if (fg('platform_ufo_vc_enable_revisions_by_experience')) {
        if (isVCRevisionEnabled('fy25.01', experienceKey) || isVCRevisionEnabled('fy25.02', experienceKey)) {
          var _this$oldVCObserver;
          (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
            startTime: startTime
          });
        }
        if (isVCRevisionEnabled('fy25.03', experienceKey)) {
          var _this$newVCObserver;
          (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
            startTime: startTime
          });
        }
      } else {
        var _this$oldVCObserver2, _this$newVCObserver2;
        (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.start({
          startTime: startTime
        });
        (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.start({
          startTime: startTime
        });
      }
    }
  }, {
    key: "stop",
    value: function stop(experienceKey) {
      if (fg('platform_ufo_vc_enable_revisions_by_experience')) {
        if (isVCRevisionEnabled('fy25.01', experienceKey) || isVCRevisionEnabled('fy25.02', experienceKey)) {
          var _this$oldVCObserver3;
          (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 || _this$oldVCObserver3.stop();
        }
        if (isVCRevisionEnabled('fy25.03', experienceKey)) {
          var _this$newVCObserver3;
          (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 || _this$newVCObserver3.stop();
        }
      } else {
        var _this$oldVCObserver4, _this$newVCObserver4;
        (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 || _this$oldVCObserver4.stop();
        (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.stop();
      }
    }
  }, {
    key: "getVCRawData",
    value: function getVCRawData() {
      var _this$oldVCObserver$g, _this$oldVCObserver5;
      return (_this$oldVCObserver$g = (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 ? void 0 : _this$oldVCObserver5.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
    }
  }, {
    key: "getVCResult",
    value: function () {
      var _getVCResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(param) {
        var _this$oldVCObserver6, _this$newVCObserver5, _ref2, experienceKey, v1v2Result, v3Result, _this$oldVCObserver7, _this$newVCObserver6, _ref3, oldResult, newResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!fg('platform_ufo_vc_enable_revisions_by_experience')) {
                _context.next = 23;
                break;
              }
              experienceKey = param.experienceKey;
              if (!(isVCRevisionEnabled('fy25.01', experienceKey) || isVCRevisionEnabled('fy25.02', experienceKey))) {
                _context.next = 8;
                break;
              }
              _context.next = 5;
              return (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 ? void 0 : _this$oldVCObserver6.getVCResult(param);
            case 5:
              _context.t0 = _context.sent;
              _context.next = 9;
              break;
            case 8:
              _context.t0 = {};
            case 9:
              v1v2Result = _context.t0;
              if (!isVCRevisionEnabled('fy25.03', experienceKey)) {
                _context.next = 16;
                break;
              }
              _context.next = 13;
              return (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 ? void 0 : _this$newVCObserver5.getVCResult({
                start: param.start,
                stop: param.stop
              });
            case 13:
              _context.t1 = _context.sent;
              _context.next = 17;
              break;
            case 16:
              _context.t1 = [];
            case 17:
              v3Result = _context.t1;
              if (v3Result) {
                _context.next = 20;
                break;
              }
              return _context.abrupt("return", v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {});
            case 20:
              return _context.abrupt("return", _objectSpread(_objectSpread({}, v1v2Result), {}, {
                'ufo:vc:rev': [].concat(_toConsumableArray((_ref2 = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _ref2 !== void 0 ? _ref2 : []), _toConsumableArray(v3Result !== null && v3Result !== void 0 ? v3Result : []))
              }));
            case 23:
              _context.next = 25;
              return (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 ? void 0 : _this$oldVCObserver7.getVCResult(param);
            case 25:
              oldResult = _context.sent;
              _context.next = 28;
              return (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 ? void 0 : _this$newVCObserver6.getVCResult({
                start: param.start,
                stop: param.stop
              });
            case 28:
              newResult = _context.sent;
              if (!(oldResult && !newResult)) {
                _context.next = 31;
                break;
              }
              return _context.abrupt("return", oldResult);
            case 31:
              return _context.abrupt("return", _objectSpread(_objectSpread({}, oldResult !== null && oldResult !== void 0 ? oldResult : {}), {}, {
                'ufo:vc:rev': [].concat(_toConsumableArray((_ref3 = oldResult === null || oldResult === void 0 ? void 0 : oldResult['ufo:vc:rev']) !== null && _ref3 !== void 0 ? _ref3 : []), _toConsumableArray(newResult !== null && newResult !== void 0 ? newResult : []))
              }));
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getVCResult(_x) {
        return _getVCResult.apply(this, arguments);
      }
      return getVCResult;
    }()
  }, {
    key: "setSSRElement",
    value: function setSSRElement(element) {
      var _this$oldVCObserver8;
      (_this$oldVCObserver8 = this.oldVCObserver) === null || _this$oldVCObserver8 === void 0 || _this$oldVCObserver8.setSSRElement(element);
    }
  }, {
    key: "setReactRootRenderStart",
    value: function setReactRootRenderStart(startTime) {
      var _this$oldVCObserver9;
      (_this$oldVCObserver9 = this.oldVCObserver) === null || _this$oldVCObserver9 === void 0 || _this$oldVCObserver9.setReactRootRenderStart(startTime || performance.now());
    }
  }, {
    key: "setReactRootRenderStop",
    value: function setReactRootRenderStop(stopTime) {
      var _this$oldVCObserver10;
      (_this$oldVCObserver10 = this.oldVCObserver) === null || _this$oldVCObserver10 === void 0 || _this$oldVCObserver10.setReactRootRenderStop(stopTime || performance.now());
    }
  }]);
}(); // Some products set this variable to indicate it is running in SSR
var isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var isReactSSR = typeof process !== 'undefined' && Boolean(((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR) || false);
export function isEnvironmentSupported() {
  // SSR environment aren't supported
  if (isReactSSR || isServer) {
    return false;
  }

  // Legacy browsers that doesn't support WeakRef
  // aren't valid
  if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') {
    return false;
  }
  if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') {
    return false;
  }
  return true;
}
export function getVCObserver() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!globalThis.__vcObserver) {
    var shouldMockVCObserver = !isEnvironmentSupported();
    globalThis.__vcObserver = shouldMockVCObserver ? new VCObserverNOOP() : new VCObserverWrapper(opts);
  }
  return globalThis.__vcObserver;
}